import React from 'react';
import { Box, FormControl, InputLabel, MenuItem } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';

interface SelectListPropsType {
  label: string;
  value: string;
  setValue: React.Dispatch<any>;
  list: any;
}

const SelectList = ({ label, value, setValue, list }: SelectListPropsType) => {
  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          label={label}
          onChange={handleChange}>
          {list &&
            list.map((element: { name: string; value: string }, index: number) => (
              <MenuItem key={index} value={element.value}>
                {element.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectList;
